import { useState } from "react";

const useOptInControls = ({ loyaltyOptIn, loyaltyReject }) => {
  const [isError, setIsError] = useState(false);
  const [isOptingIn, setIsOptingIn] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);

  const onJoin = async () => {
    setIsError(false);
    setIsOptingIn(true);

    try {
      await loyaltyOptIn();
    } catch (e) {
      setIsError(true);
    } finally {
      setIsOptingIn(false);
    }
  };

  const onReject = () => {
    setIsError(false);
    setIsRejecting(true);

    loyaltyReject();
  };

  return {
    isError,
    isOptingIn,
    isRejecting,
    onJoin,
    onReject
  };
};

export default useOptInControls;
